export class Dibels8TranslatorClient {
    static BASE_URL = '/dibels8-api/aggregate-results/v1/results';

    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    getRequestHeaders = (token = '', staffId = '') => ({
        ...(token && { authorization: `Bearer ${token}` }),
        ...(staffId && { staff: staffId }),
    });

    /**
     * Get D8 results, student statuses and zones of growth for a list of student ids and optional school year.
     * @param {Array<String>} studentUids List of student ids. Should be not empty.
     * @param {String} [schoolYear] School year to get results. If not provided, all years are included.
     * @param classId class id, optional parameter.
     * @param {String} [instContext = undefined] If set, this field will enable support of custom gating rules
     * @param {Boolean} [includeInvalidated=true] If true, invalidated results for all measures are included
     * @param {Boolean} [withCroppedResults=true] If true, result details for PSF/NWF measures are in cropped format
     * @param {Boolean} [withZog=true] If true, zones of growth data for each student is included
     * @param token return from keycloak need to sending request with Bearer.
     * @param {String} staffId - staffId for an additional header used in results caching.
     * @returns {Promise}
     */
    async getResults(
        studentUids,
        schoolYear,
        classId,
        instContext,
        includeInvalidated = true,
        withCroppedResults = true,
        withZog = true,
        token = '',
        staffId = '',
    ) {
        const headers = this.getRequestHeaders(token, staffId);

        return this.httpClient.get(Dibels8TranslatorClient.BASE_URL, {
            params: {
                studentUids: studentUids.join(','),
                schoolYear,
                classId,
                instContext,
                includeInvalidated,
                withCroppedResults,
                withZog,
            },
            headers,
        });
    }
}

export default Dibels8TranslatorClient;
